/**
 * Checks if an error is from the user rejecting a transaction
 * @param error The error object to check
 * @returns true if the error is from user rejection, false otherwise
 */
export function isUserRejection(error: any): boolean {
  if (!error) return false

  // Check for common user rejection error codes
  if (error.code === 4001 || error.code === 'ACTION_REJECTED' || error.name === 'UserRejectedRequestError') {
    return true
  }

  // Check error message for rejection keywords
  const errorMessage = error.message?.toLowerCase() || error.toString().toLowerCase()
  return (
    errorMessage.includes('user rejected') ||
    errorMessage.includes('user denied') ||
    errorMessage.includes('user cancelled') ||
    errorMessage.includes('rejected by user') ||
    errorMessage.includes('transaction was rejected')
  )
}
